import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';

const AddEmployee = () => {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [form, setForm] = useState({
    employeeId: '', name: '', email: '', phone: '', department: '',
    designation: '', joiningDate: '', salary: '', status: 'Active'
  });
  const [createLogin, setCreateLogin] = useState(true);
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('employee');

  useEffect(() => {
    api.get('/departments').then(res => setDepartments(res.data)).catch(() => {});
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (createLogin && !password) {
      toast.error('Please enter a password for the login account');
      return;
    }
    try {
      const payload = { ...form, salary: Number(form.salary) };
      if (createLogin) {
        payload.createLogin = true;
        payload.password = password;
        payload.role = role;
      }
      await api.post('/employees', payload);
      toast.success(createLogin ? 'Employee added with login account' : 'Employee added successfully');
      navigate('/employees');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add employee');
    }
  };

  return (
    <div className="form-card">
      <h2>Add Employee</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group"><label>Employee ID</label><input name="employeeId" value={form.employeeId} onChange={handleChange} required /></div>
          <div className="form-group"><label>Name</label><input name="name" value={form.name} onChange={handleChange} required /></div>
          <div className="form-group"><label>Email</label><input type="email" name="email" value={form.email} onChange={handleChange} required /></div>
          <div className="form-group"><label>Phone</label><input name="phone" value={form.phone} onChange={handleChange} required /></div>
          <div className="form-group"><label>Department</label>
            <select name="department" value={form.department} onChange={handleChange} required>
              <option value="">Select Department</option>
              {departments.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
            </select>
          </div>
          <div className="form-group"><label>Designation</label><input name="designation" value={form.designation} onChange={handleChange} required /></div>
          <div className="form-group"><label>Joining Date</label><input type="date" name="joiningDate" value={form.joiningDate} onChange={handleChange} required /></div>
          <div className="form-group"><label>Salary</label><input type="number" name="salary" value={form.salary} onChange={handleChange} required /></div>
          <div className="form-group"><label>Status</label>
            <select name="status" value={form.status} onChange={handleChange}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* Login Account Section */}
        <div className="login-account-section">
          <div className="login-account-toggle">
            <label className="toggle-label">
              <input
                type="checkbox"
                checked={createLogin}
                onChange={(e) => setCreateLogin(e.target.checked)}
              />
              <span>Create login account for this employee</span>
            </label>
          </div>
          {createLogin && (
            <div className="form-grid" style={{ marginTop: '0.75rem' }}>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Set login password"
                  required={createLogin}
                />
              </div>
              <div className="form-group">
                <label>Role</label>
                <select value={role} onChange={(e) => setRole(e.target.value)}>
                  <option value="employee">Employee</option>
                  <option value="hr">HR</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            </div>
          )}
        </div>

        <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
          <button type="submit" className="btn-primary">Add Employee</button>
          <button type="button" className="btn-secondary" onClick={() => navigate('/employees')}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default AddEmployee;
